/**
 * LeadsFilters — Iter 156.10. Extracted from `LeadsPage.jsx`.
 * Renders the search bar + collapsible filter chips (status, category,
 * assignee). Owns no state; all bound from useLeads().
 */
import { Filter, Search, X } from "lucide-react";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "../../components/ui/select";

export default function LeadsFilters({
  search, setSearch, setPage,
  showFilters, setShowFilters, hasFilters, clearFilters,
  statusFilter, setStatusFilter,
  categoryFilter, setCategoryFilter,
  assignedFilter, setAssignedFilter, salespeople,
  STATUSES, CATEGORIES, user,
}) {
  return (
    <div className="bento-card mb-6">
      <div className="flex flex-col lg:flex-row gap-4">
        <div className="flex-1 relative">
          <Search size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#A8A29E]" />
          <input
            type="text"
            value={search}
            onChange={(e) => { setSearch(e.target.value); setPage(1); }}
            placeholder="Search by name or phone..."
            className="form-input pl-10"
            data-testid="search-leads-input"
          />
        </div>
        <button
          onClick={() => setShowFilters(!showFilters)}
          className={`btn-secondary flex items-center gap-2 ${hasFilters ? "border-[#BC4B35] text-[#BC4B35]" : ""}`}
          data-testid="toggle-filters-btn"
        >
          <Filter size={18} /> Filters {hasFilters && `(${[statusFilter, categoryFilter, assignedFilter].filter(Boolean).length})`}
        </button>
      </div>

      {showFilters && (
        <div className="mt-4 pt-4 border-t border-[#E7E5E4] flex flex-wrap gap-4">
          <div className="w-48">
            <label className="block text-xs font-medium text-[#57534E] mb-1 uppercase tracking-wider">Status</label>
            <Select value={statusFilter || "all"} onValueChange={(v) => { setStatusFilter(v === "all" ? "" : v); setPage(1); }}>
              <SelectTrigger data-testid="filter-status"><SelectValue placeholder="All statuses" /></SelectTrigger>
              <SelectContent>
                <SelectItem value="all">All statuses</SelectItem>
                {STATUSES.map((s) => <SelectItem key={s.value} value={s.value}>{s.label}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>

          <div className="w-48">
            <label className="block text-xs font-medium text-[#57534E] mb-1 uppercase tracking-wider">Category</label>
            <Select value={categoryFilter || "all"} onValueChange={(v) => { setCategoryFilter(v === "all" ? "" : v); setPage(1); }}>
              <SelectTrigger data-testid="filter-category"><SelectValue placeholder="All categories" /></SelectTrigger>
              <SelectContent>
                <SelectItem value="all">All categories</SelectItem>
                {CATEGORIES.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>

          {(user?.role === "admin" || user?.role === "super_admin" || user?.role === "leader") && (
            <div className="w-48">
              <label className="block text-xs font-medium text-[#57534E] mb-1 uppercase tracking-wider">Assigned To</label>
              <Select value={assignedFilter || "all"} onValueChange={(v) => { setAssignedFilter(v === "all" ? "" : v); setPage(1); }}>
                <SelectTrigger data-testid="filter-assigned"><SelectValue placeholder="All salespeople" /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="all">All salespeople</SelectItem>
                  <SelectItem value="unassigned">Unassigned</SelectItem>
                  {salespeople.map((sp) => <SelectItem key={sp.id} value={sp.id}>{sp.name}</SelectItem>)}
                </SelectContent>
              </Select>
            </div>
          )}

          {hasFilters && (
            <button onClick={clearFilters} className="btn-ghost text-sm flex items-center gap-1 self-end" data-testid="clear-filters-btn">
              <X size={16} /> Clear
            </button>
          )}
        </div>
      )}
    </div>
  );
}
